import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const endPoint = '/marketing-promotions';

export default {
  async getListMarketingPromotion(params) {
    const queryString = getParamsFormObject(params);
    const response = await axiosClient.get(`${endPoint}${queryString}`);
    return response.data;
  },

  async getDetailMarketingPromotion(id) {
    const response = await axiosClient.get(`${endPoint}/${id}`);
    return response.data;
  },
  async createMarketingPromotion(data) {
    const response = await axiosClient.post(endPoint, data);
    return response.data;
  },
  async updateMarketingPromotion(id, data) {
    const response = await axiosClient.put(`${endPoint}/${id}`, data);
    return response.data;
  },
  async delete(id) {
    const response = await axiosClient.delete(`${endPoint}/${id}`);
    return response.data;
  },
};
